import {useCallback, useEffect, useState} from 'react'
import {useReducedMotion} from 'framer-motion'

const useVideoControl = (init = false, videoRef) => {
    const shouldReduceMotion = useReducedMotion()
    const [isPlaying, setIsPlaying] = useState(init && !shouldReduceMotion ? true : false)

    const onVideoToggle = useCallback(() => {
        setIsPlaying((prev) => !prev)
    }, [])

    useEffect(() => {
        if (!videoRef?.current) return
        if (isPlaying) {
            videoRef.current.play()
        } else {
            videoRef.current.pause()
        }
    }, [isPlaying, videoRef])

    return [isPlaying, onVideoToggle]
}

export default useVideoControl
